import apiClient from './client';
import type { AssetRuntime, AssetRuntimeDeployPayload, AssetRuntimeType } from '../types/assetRuntime';

export async function listAssetRuntimes(agentId: string): Promise<{ agent_id: string; runtimes: AssetRuntime[] }> {
  const res = await apiClient.get(`/agents/${agentId}/asset-runtimes`);
  return res.data;
}

export async function deployAssetRuntime(
  agentId: string,
  payload: AssetRuntimeDeployPayload,
): Promise<AssetRuntime> {
  const res = await apiClient.post(`/agents/${agentId}/asset-runtimes`, payload);
  return res.data;
}

export async function startAssetRuntime(agentId: string, runtimeId: string): Promise<AssetRuntime> {
  const res = await apiClient.post(`/agents/${agentId}/asset-runtimes/${runtimeId}/start`);
  return res.data;
}

export async function stopAssetRuntime(agentId: string, runtimeId: string): Promise<AssetRuntime> {
  const res = await apiClient.post(`/agents/${agentId}/asset-runtimes/${runtimeId}/stop`);
  return res.data;
}

export async function restartAssetRuntime(agentId: string, runtimeId: string): Promise<AssetRuntime> {
  const res = await apiClient.post(`/agents/${agentId}/asset-runtimes/${runtimeId}/restart`);
  return res.data;
}

export async function deleteAssetRuntime(agentId: string, runtimeId: string): Promise<void> {
  await apiClient.delete(`/agents/${agentId}/asset-runtimes/${runtimeId}`);
}

export function getAssetEndpoint(runtime: AssetRuntime | undefined, path: string): string {
  if (!runtime?.endpoint_url) return '';
  return `${runtime.endpoint_url}${path}`;
}

export function assetTypeLabel(type: AssetRuntimeType): string {
  const labels: Record<AssetRuntimeType, string> = {
    all: '全部资产',
    skill: '技能',
    knowledge: '知识库',
    mcp: 'MCP 工具',
    workflow: '工作流',
    persona: '人设',
  };
  return labels[type] || type;
}
